import {GenericService, ResultType} from '@/shared/xhttp';
import {Projet} from '@/models';

export class ProjetService extends GenericService<Projet> {
}